import { FC } from "react";
import { useTranslation } from "react-i18next";

import { parseBoolean } from "@ryde/shared";

import { FramerTooltip } from "../../common";
import { IRenderColumnTemplate } from "./_core";
import { BooleanImageIconCellStyled } from "./boolean-image-icon-cell.styled";

export const BooleanImageIconCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
  gridAttributes,
}) => {
  const { t } = useTranslation();
  const isOn = parseBoolean(value);
  const icon = isOn ? gridAttributes?.imageOn : gridAttributes?.imageOff;

  if (!icon) {
    return null;
  }

  const tooltipKey = gridAttributes?.translationPath;
  const tooltip = tooltipKey ? t(tooltipKey) : undefined;

  const cell = (
    <BooleanImageIconCellStyled role="img" aria-hidden>
      {icon}
    </BooleanImageIconCellStyled>
  );

  if (!tooltip) {
    return cell;
  }

  return (
    <FramerTooltip content={tooltip} rtlStrippedBottomLeftPlacement>
      <div>{cell}</div>
    </FramerTooltip>
  );
};
